<app-alert-box-component (OnButtonClick)="onAlertButtonClick($event)" (OnAlertClose)="closeAlert($event)"
  (OnAlertVisibility)="alertVisibility($event)" [bShowSecondButton]="bShowSecondAlertButton"
  [alertHeaderText]="alertHeaderText" [alertBodyText]="alertBodyText" [closeButtonText]="alertCloseButtonText"
  [secondButtonText]="alertSecondButtonText" [data]="alertBoxData" [bAlert]="bAlert"></app-alert-box-component>

<div *ngIf="true">
  <c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
    <c-container fluid>
      <form cForm class="row" [formGroup]="cifSearchForm" (ngSubmit)="getRetailCustomer()">
        <c-row>
          <c-col md="auto">
            <c-input-group class="has-validation">
              <span cInputGroupText>
                Email
              </span>
              <input [valid]="customerEmailValid" class="w-25" (ngModelChange)="emailChange()" cFormControl
                formControlName="searchByEmailControl" id="EMAIL" type="email" />
              <c-form-feedback
                [valid]="isCustomerEmailValid() === ''?true:false">{{isCustomerEmailValid()}}</c-form-feedback>
            </c-input-group>
          </c-col>
          <c-col>
            <button cBgColor="{{searchBtnColor}}" cButton type="submit">
              Search
            </button>
          </c-col>
          <c-col *ngIf="bShowCustomer" md="auto">
            <button cBgColor="danger" cButton (click)="resetPasswordPrompt()">
              Reset Password
            </button>
          </c-col>
        </c-row>
        <div class="row">
          <div class="col-md-auto">

          </div>
          <div class="col col-lg-2">

          </div>

          <div *ngIf="false">
            <div *ngIf="bShowCustomer && bCustomerActive" class="col col-lg-2">
              <button cBgColor="danger" cButton>
                Deactivate
              </button>
            </div>
            <div *ngIf="bShowCustomer && !bCustomerActive" class="col col-lg-2">
              <button cBgColor="success" cButton>
                Activate
              </button>
            </div>
          </div>
        </div>
      </form>
    </c-container>
  </c-navbar>
</div>
<div>
  <form *ngIf="bShowCustomer" cForm [formGroup]="customerProfileForm" class="needs-validation" [gutter]="3" novalidate>
    <div class="row">
      <div class="col-6">
        <label cLabel for="inputCIF">CIF</label>
        <input readonly cFormControl id="inputCIF" type="text" formControlName="customerCIF" />
      </div>
      <div class="col-6">
        <label cLabel for="inputName">Name</label>
        <input readonly cFormControl id="inputName" type="text" formControlName="customerName" />
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-6">
        <label cLabel for="inputEmail">Email Id</label>
        <input readonly cFormControl id="inputEmail" type="email" formControlName="customerEmail" />
      </div>
      <div class="col-6">
        <label cLabel for="inputMobileNumber">Mobile Number</label>
        <input readonly cFormControl id="inputMobileNumber" type="tel" formControlName="customerMobile" />
      </div>
    </div>
  </form>
</div>